import {
  useClickOutsideEventListener,
  useClickOutsideRefsEventListener,
  useEventListener
} from "@outschool/ui-utils";

export { useClickOutsideEventListener, useClickOutsideRefsEventListener };

export default useEventListener;
